module.exports = __webpack_public_path__ + "media/images/about-slider-img-03-117c3204b60844021d04beae6820a1cd.jpg";